import { render, staticRenderFns } from "./HorizontalScroller.vue?vue&type=template&id=6dfdc2b0&scoped=true&lang=pug&"
import script from "./HorizontalScroller.vue?vue&type=script&lang=js&"
export * from "./HorizontalScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdc2b0",
  null
  
)

export default component.exports